import { createRouter, createWebHistory } from 'vue-router'
import useStrapiStore from '@/composition/strapiStore'
import DiscoverView from '@/views/DiscoverView.vue'
import FavouritesView from '@/views/FavouritesView.vue'
import BuildView from '@/views/BuildView.vue'
import PageView from '@/views/PageView.vue'
import type { LocaleCode } from '@/i18n'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '',
      redirect: () => {
        const locale = localStorage.getItem('user-locale') || 'en'
        return `/${locale}/landing`
      },
    },
    {
      path: '/stories',
      redirect: () => {
        const locale = localStorage.getItem('user-locale') || 'en'
        return `/${locale}/stories`
      },
    },
    {
      path: '/compliance',
      redirect: () => {
        const locale = localStorage.getItem('user-locale') || 'en'
        return `/${locale}/compliance`
      },
    },
    {
      path: `/:locale/discover`,
      name: 'discover',
      component: DiscoverView,
    },
    {
      path: `/:locale/favourites`,
      name: 'favourites',
      component: FavouritesView,
    },
    {
      path: `/:locale/build`,
      name: 'build',
      component: BuildView,
    },
    {
      path: '/:locale/:pagename',
      name: 'page',
      component: PageView,
    },
    {
      path: '/:locale(.*)*',
      redirect: () => {
        const locale = localStorage.getItem('user-locale') || 'en'
        return `/${locale}/not-found`
      },
    },
  ],
  scrollBehavior(to) {
    if (!to.hash) return { top: 0 }

    return new Promise((resolve) => {
      const hash = to.hash

      const tryScroll = (attemptsLeft = 30) => {
        const el = document.querySelector(hash)
        if (el) {
          resolve({ el: hash, behavior: 'smooth' })
          return
        }

        if (attemptsLeft <= 0) {
          resolve({ top: 0 })
          return
        }

        requestAnimationFrame(() => tryScroll(attemptsLeft - 1))
      }

      tryScroll()
    })
  },
})

router.beforeEach((to) => {
  const strapiStore = useStrapiStore()
  const locale = localStorage.getItem('user-locale') as LocaleCode

  const pageName = to.params.pagename?.toString().toLowerCase()
  if (pageName) {
    strapiStore.actions.loadPage(pageName, true, locale)
  }
})

router.onError((error) => {
  console.error('Router error:', error)
})

export default router
